import { useState } from "react";
import { Send } from "lucide-react";

export default function MessageForm() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    subject: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({ fullName: "", email: "", subject: "", message: "" });
    }, 4000);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <section className="max-w-4xl mx-auto px-4 py-6 md:py-10">
      {/* Outer Card Wrapper */}
      <div className="relative w-full rounded-[32px] overflow-hidden border border-gray-100 bg-white ">

        {/* ── DESKTOP BACKGROUND: covers whole card ── */}
    <div
  className="hidden md:block absolute inset-0 w-full h-full bg-cover bg-left bg-no-repeat pointer-events-none"
  style={{ backgroundImage: "url('/img/contact-us/Group 1707478973.svg')" }}
/>

        {/* ── CONTENT GRID ON TOP ── */}
        <div className="relative z-10 grid md:grid-cols-12 w-full ">

          {/* Left Column (mobile: top illustration as background) */}
          <div
            className="block md:hidden w-full aspect-[400/450] bg-cover bg-top bg-no-repeat"
            style={{ backgroundImage: "url('/img/contact-us/bgimgfm.svg')" }}
          />
          <div className="hidden md:block md:col-span-6 md:min-h-[420px]" />

          {/* Left Column (mobile: top illustration, natural height — no crop) */}


          {/* Right Column: Form Section */}
          <div className="md:col-span-6 p-5 md:p-8 lg:p-10 flex flex-col justify-center bg-white">
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-1.5 tracking-tight">
              Send Us a Message
            </h2>
            <p className="text-gray-500 text-xs md:text-sm leading-relaxed mb-5">
              Fill Out the form below and we'll get back to you as soon as possiblle.
            </p>

            {submitted ? (
              <div className="bg-purple-50/90 backdrop-blur-sm border border-purple-200 text-purple-800 p-5 rounded-2xl text-center space-y-2 animate-fadeIn">
                <div className="text-3xl">✨</div>
                <h3 className="font-bold text-base">Message Sent Successfully!</h3>
                <p className="text-xs text-purple-600">
                  Thank you for contacting us. We will get back to you shortly.
                </p>
              </div>
            ) : (
              <form className="space-y-3" onSubmit={handleSubmit}>
                {/* Full Name */}
                <div>
                  <input
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    placeholder="Enter your Full Name*"
                    className="w-full bg-white/90 border border-gray-100 rounded-2xl px-4 py-2.5 text-xs md:text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-purple-500 focus:ring-2 focus:ring-purple-100 transition-all shadow-sm"
                    required
                  />
                </div>

                {/* Email Address */}
                <div>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email Address*"
                    className="w-full bg-white/90 border border-gray-100 rounded-2xl px-4 py-2.5 text-xs md:text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-purple-500 focus:ring-2 focus:ring-purple-100 transition-all shadow-sm"
                    required
                  />
                </div>

                {/* Subject */}
                <div>
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="Subject*"
                    className="w-full bg-white/90 border border-gray-100 rounded-2xl px-4 py-2.5 text-xs md:text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-purple-500 focus:ring-2 focus:ring-purple-100 transition-all shadow-sm"
                    required
                  />
                </div>

                {/* Write your Message */}
                <div>
                  <textarea
                    name="message"
                    rows={4}
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Write your Message..."
                    className="w-full bg-white/90 border border-gray-100 rounded-2xl px-4 py-2.5 text-xs md:text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-purple-500 focus:ring-2 focus:ring-purple-100 transition-all shadow-sm resize-none"
                    required
                  />
                </div>

                {/* Submit Button */}
                <div className="pt-1.5">
                  <button
                    type="submit"
                    className="w-full bg-[#6B11D4] hover:bg-[#590CB7] active:scale-[0.99] text-white font-semibold py-3 px-6 rounded-full flex items-center justify-center gap-2 shadow-md hover:shadow-lg transition-all text-xs md:text-sm cursor-pointer"
                  >
                    <Send size={15} className="text-white fill-white/20" />
                    <span>Send Message</span>
                  </button>
                </div>
              </form>
            )}
          </div>

        </div>

      </div>
    </section>
  );
}